import { hasValidationsToFix } from '../../reducers/validations';
import {
  INPUT_CHANGE,
  saveHomeCalculatorAddress,
  resolveCalculations,
} from '../actions';

import fetchZipByCity, { UPDATE_RESOLVED_ZIP } from './fetchZipByCity';
import saveToProfile from './save-to-profile';

export default ({ city, zip }, addressType = null) => {
  const locationInfo = city.split(',');
  const state = locationInfo[1].trim();
  const cityName = locationInfo[0].trim();

  return (dispatch, getState) => {
    if (zip === undefined) {
      dispatch(
        fetchZipByCity({
          city: cityName,
          state,
        })
      );
    } else {
      dispatch({
        type: UPDATE_RESOLVED_ZIP,
        zip,
      });
    }

    const newAddress = { city: cityName, state, zip };
    dispatch(saveHomeCalculatorAddress(newAddress, addressType));

    dispatch({
      type: INPUT_CHANGE,
      manualInputs: {
        city: cityName,
        state,
        zip,
      },
    });

    if (!hasValidationsToFix(getState())) {
      dispatch(resolveCalculations());
    }

    dispatch(saveToProfile());
  };
};
